import { IFRResource } from "app/resources/ifrresource";

export class CompanyResource extends IFRResource {

    rid: number;

	private name: String;
	
    private country: number;
}
